/* Add JavaScript Here*/

/* -------------------- */
/* Redeemly custom code */
/* -------------------- */

function redeemly_initializeCustomScript() {
  function redeemly_setCartDrawerWidgetVisible(visible) {
    const redeemly_cartDrawerWidget = document.querySelector('#mcb_cart_widget_app_embed')
    if (redeemly_cartDrawerWidget) {
      redeemly_cartDrawerWidget.style.display = visible ? "block" : "none"
    }
  }
  
  const redeemly_cartDrawerObserver = new MutationObserver(() => {
    // Get the current state of the cart drawer
    const redeemly_cartDrawerItems = document.querySelector('section[data-cart-drawer-line-items]');
    const redeemly_cartDrawerIsEmpty = !redeemly_cartDrawerItems || redeemly_cartDrawerItems.children.length === 0
    redeemly_setCartDrawerWidgetVisible(!redeemly_cartDrawerIsEmpty)
  });

  // Select the target element to observe
  const redeemly_cartDrawerItems = document.querySelector('section[data-cart-drawer-line-items]');

  const config = {
    childList: true,
    subtree: true
  };

  // Start observing if the element exists
  if (redeemly_cartDrawerItems) {
      redeemly_cartDrawerObserver.observe(redeemly_cartDrawerItems, config);
  }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redeemly_initializeCustomScript);
} else {
    redeemly_initializeCustomScript();
}